// Student-supplied attachment answers are a JSON string array of URLs. The
// content reaches the grader unvalidated on old rows, so parsing must never
// throw (a bad row used to crash the whole grading modal) and only https
// links may be rendered or opened: a `javascript:` URL handed to
// window.open runs in this portal's origin.
//
// Shared by both apps' grading surfaces (it used to be a byte-identical twin
// in each app tree).
export type AttachmentObject = { type: string; url: string };

const SAFE_URL = /^https:\/\/[^\s]+$/i;

export function parseAttachmentAnswer(raw: unknown): {
	attachments: AttachmentObject[];
	unreadable: boolean;
} {
	if (typeof raw !== 'string' || raw.trim() === '') {
		return { attachments: [], unreadable: false };
	}
	let parsed: unknown;
	try {
		parsed = JSON.parse(raw);
	} catch {
		return { attachments: [], unreadable: true };
	}
	if (!Array.isArray(parsed)) return { attachments: [], unreadable: true };
	const attachments = parsed
		.filter((url): url is string => typeof url === 'string' && SAFE_URL.test(url))
		.map((url) => ({
			url,
			type: (url.split('?')[0].split('.').pop() ?? '').toLowerCase(),
		}));
	return { attachments, unreadable: attachments.length !== parsed.length };
}

export function openAttachment(url: string) {
	if (!SAFE_URL.test(url)) return;
	window.open(url, '_blank', 'noopener,noreferrer');
}
